import { MediaFormatEnum } from '../../../../../general-settings/enums/mediaFormat.enum';
import { THUMB_GAP } from '../../consts/gallery.consts';
import { ThumbLayout } from '../../interfaces/productGallery.interfaces';
import { getMediaAspectRatio } from '../../utils/mediaAspectRatio.utils';

export const RECTANGULAR_ASPECT_RATIO = getMediaAspectRatio(MediaFormatEnum.RECTANGULAR);

const THUMB_COLUMNS = 4;
const THUMB_ROWS = 1;

export const getRectangularGalleryColumnWidth = (galleryHeight: number) => {
  const availableHeight = galleryHeight - THUMB_GAP * THUMB_ROWS;

  if (availableHeight <= 0) {
    return 0;
  }

  const thumbRowsShare = THUMB_ROWS / THUMB_COLUMNS;
  const thumbGaps = (THUMB_GAP * (THUMB_COLUMNS - 1) * THUMB_ROWS) / THUMB_COLUMNS;

  return (availableHeight * RECTANGULAR_ASPECT_RATIO + thumbGaps) / (1 + thumbRowsShare);
};

export const getRectangularThumbLayout = (galleryWidth: number): ThumbLayout => {
  const thumbWidth = Math.max(0, (galleryWidth - THUMB_GAP * (THUMB_COLUMNS - 1)) / THUMB_COLUMNS);

  return {
    thumbWidth,
    thumbHeight: thumbWidth / RECTANGULAR_ASPECT_RATIO,
    thumbRows: THUMB_ROWS,
    thumbColumns: THUMB_COLUMNS,
    maxThumbs: THUMB_COLUMNS * THUMB_ROWS,
  };
};
